import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { memo } from "react";
import { Card } from "react-bootstrap";
import { useSpring, animated } from "react-spring";
import AppLoader from "../common/AppLoader";

type NumberProps = {
  value: number;
  size?: 'sm' | 'md' | 'lg';
}

export const AnimatedNumber = memo(({ value, size }: NumberProps) => {
  const { number } = useSpring({
    from: { number: 0 },
    number: value,
    config: { mass: 1, tension: 20, friction: 10 },
  });

  return size === 'sm'
    ? <animated.h5 className="animated-number">{number.to((n) => n.toFixed(0))}</animated.h5>
    : size === 'md'
      ? <animated.h3 className="animated-number">{number.to((n) => n.toFixed(0))}</animated.h3>
      : <animated.h1 className="animated-number">{number.to((n) => n.toFixed(0))}</animated.h1>
})

type Props = {
  title: string;
  number?: number;
  icon: IconDefinition;
  type: 'services' | 'applications' | 'datasets' | 'models';
}

export const AnimatedNumberWidget = memo(({ title, number, icon, type = "services" }: Props) => {
  return (
    <Card className={`animated-number-widget ${type}`}>
      <Card.Body>
        <div className="d-flex align-items-center mb-2">
          <FontAwesomeIcon className="text-secondary me-1" icon={icon} />
          <h6 className="ms-2 widget-title">{title}</h6>
        </div>
        {number === undefined
          ? <AppLoader justify="flex-end" size={40} />
          : <AnimatedNumber value={number} />}
      </Card.Body>
    </Card>
  )
})